export default __webpack_public_path__ + "static/media/Group 3221@2x.b5293676.png";